import { render, staticRenderFns } from "./SRTServer.vue?vue&type=template&id=6c9a7696&scoped=true&"
import script from "./SRTServer.vue?vue&type=script&lang=js&"
export * from "./SRTServer.vue?vue&type=script&lang=js&"
import style0 from "./SRTServer.vue?vue&type=style&index=0&id=6c9a7696&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9a7696",
  null
  
)

export default component.exports